import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { PipeActions } from 'Redux/thunks/pipes.thunks';

import Page from '../components/page';
import Button from 'Common/Button/Button';
import PageHeader, { PageHeaderTitle, PageHeaderGroup } from '../components/page-header';
import { TabbedNav } from '../components/tabbed-nav/TabbedNav.view';

import { TestID } from 'src/testID';

import type { RootState } from 'src/types/state.types';

export const FlowsListPage: React.FC<React.PropsWithChildren> = ({ children }) => {
  const subId = useSelector((state: RootState) => state.subscription.id);

  const dispatch = useDispatch();

  const loadAll = () => {
    dispatch(PipeActions.loadAll());
  };

  return (
    // @ts-ignore
    <Page>
      {/* @ts-ignore */}
      <PageHeader>
        <PageHeaderTitle>Flows</PageHeaderTitle>
        <PageHeaderGroup>
          <Button theme="primary" onClick={loadAll}>
            Refresh
          </Button>
        </PageHeaderGroup>
      </PageHeader>
      <TabbedNav
        nav={[
          {
            id: '',
            label: 'List all',
            tooltip: 'List all',
            testId: TestID.FlowsListAllTab,
            to: `/subscription/${subId}/flows/all`,
          },
        ]}
      >
        {children}
      </TabbedNav>
    </Page>
  );
};
